module.exports = __webpack_public_path__ + "img/Solidarity-Fund.ceacadd4.svg";